<template>
  <v-menu
    v-model="menuOpen"
    offset-y
    transition="slide-y-transition"
    rounded="1"
    :nudge-top="-10"
    content-class="filter__list LKHeader__menu"
  >
    <template #activator="{ on, attrs }">
      <a
        id="profileBtn"
        class="nav__button nav__button-rounded profile-btn w-inline-block no-margin"
        v-bind="attrs"
        v-on="on"
      >
        <span
          class="nav__button-img"
          v-html="icon"
        />
        <div
          class="text-lg-bold mod--nav mod--button LKHeader__name"
          v-text="profile.username"
        />
      </a>
    </template>

    <template v-for="(item, index) in menuList">
      <v-menu
        v-if="item.submenu"
        :key="index"
        v-model="submenuOpen[index]"
        offset-x
        open-on-hover
        open-on-click
        left
        transition="slide-x-transition"
        content-class="LKHeader__submenu"
        :nudge-left="-1"
      >
        <template #activator="{ on: onSubmenu, attrs: attrsSubmenu }">
          <div
            class="filter__option filter__option--hoverable w-inline-block text-md-bold"
            v-bind="attrsSubmenu"
            v-on="onSubmenu"
            v-text="item.label"
          />
        </template>
        <template v-for="(subitem, subindex) in item.submenu">
          <router-link
            :key="subindex"
            :to="subitem.route"
            class="filter__option w-inline-block text-md-bold"
            @click.native="closeAllMenus"
            v-text="subitem.label"
          />
        </template>
      </v-menu>
      <router-link
        v-else
        :key="index"
        :to="item.route"
        class="filter__option w-inline-block text-md-bold"
        @click.native="closeAllMenus"
        v-text="item.label"
      />
    </template>
  </v-menu>
</template>

<script>
import { LK_REPORT_ROUTES } from '@/views/LKReports/utils'
import { LK_REPORT_DATA_COLLECTIONS_ROUTES } from '@/views/LKReportsDataCollections/utils'
import { DASHBOARD_LK_ROUTES } from '@/views/DashboardLK/utils'
import { LK_PROFILE_ROUTES } from '@/views/LKProfile/utils'
import { lkStoreModule } from '@/store/modules/lk'


const ROADMAPS_MENU_ITEM = {
  route: { name: LK_REPORT_ROUTES.LAYOUT },
  label: 'Дорожные карты',
}

const DATA_COLLECTIONS_MENU_ITEM = {
  route: { name: LK_REPORT_DATA_COLLECTIONS_ROUTES.LAYOUT },
  label: 'Сборы данных',
}

const ADMIN_DASHBOARD_MENU = {
  route: { name: DASHBOARD_LK_ROUTES.LAYOUT },
  label: 'Администрирование',
}

const PROFILE_MENU = {
  route: { name: LK_PROFILE_ROUTES.LAYOUT },
  label: 'Профиль',
}

export default {
  name: 'LKHeaderUserMenu',
  props: {
    reportless: Boolean,
    profile: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    icon: null,
    menuOpen: false,
    submenuOpen: {},
  }),
  computed: {
    menuList() {
      const list = []

      const hasPublicationsCurator = this.profile?.publications_curator?.length > 0
      const hasRoadmaps = !this.reportless
      const lkStore = lkStoreModule.context(this.$store)
      const showDataCollections = hasPublicationsCurator || lkStore.state.isAutoCurator === true

      if (showDataCollections || hasRoadmaps) {
        if (showDataCollections && hasRoadmaps) {
          list.unshift({
            label: 'Отчеты',
            submenu: [
              ROADMAPS_MENU_ITEM,
              DATA_COLLECTIONS_MENU_ITEM,
            ],
          })
        } else if (showDataCollections) {
          list.unshift({
            label: 'Отчеты',
            submenu: [
              DATA_COLLECTIONS_MENU_ITEM,
            ],
          })
        } else if (hasRoadmaps) {
          // Если только дорожные карты - показываем прямой переход на старый роут отчетов
          list.unshift({
            label: 'Отчеты',
            submenu: [
              ROADMAPS_MENU_ITEM,
            ],
          })
        }
      }

      if (this.profile.is_superuser || this.profile.is_admin) {
        list.unshift(ADMIN_DASHBOARD_MENU)
      }

      list.unshift(PROFILE_MENU)

      return list
    },
  },
  watch: {
    async menuOpen(isOpen) {
      if (isOpen) {
        const lkStore = lkStoreModule.context(this.$store)
        if (lkStore.state.isAutoCurator === null) {
          await lkStore.actions.checkIsAutoCurator()
        }
      }
    },
  },
  async created() {
    this.icon = (await import(
      '!raw-loader!@/../public/images/person.svg'
    )).default
  },
  methods: {
    closeAllMenus() {
      this.menuOpen = false
      this.submenuOpen = {}
    },
  },
}
</script>

<style scoped>
.profile-btn {
  padding-right: 1.15rem !important;
  padding-left: 1.15rem !important;
}
</style>

<style>
.LKHeader__submenu {
  position: absolute;
  top: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  width: 200px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1);
}

.LKHeader__submenu .filter__option {
  min-width: 200px;
}

.filter__option--hoverable {
  position: relative;
  cursor: pointer;
}

.filter__option--hoverable::after {
  content: '›';
  position: absolute;
  right: 16px;
  font-size: 20px;
  font-weight: bold;
  color: #1565c0;
}
</style>

